import { useLayoutStore, type Tab } from '../store/layoutStore';
import { useProxyStore } from '../store/proxy-store';
import { useReplaySessionStore } from '../store/replaySessionStore';
import { focusReplayView } from './replayOpenRequest.utils';
import type { PortalToolNavigation } from '@terra/shared-dto-chat-types';

function openMainContentTabForType({
  id,
  title,
  type,
}: {
  id: string;
  title: string;
  type: 'replay' | 'intercept' | 'match-replace';
}): void {
  const {
    mainContentTabs,
    openMainContentTab,
    setActiveMainContentTab,
    setSidebarTab,
  } = useLayoutStore.getState();

  setSidebarTab(type);

  const existingTab = mainContentTabs.find((tab: Tab) => tab.type === type);
  if (existingTab) {
    setActiveMainContentTab(existingTab.id);
    return;
  }

  openMainContentTab({ id, title, type });
}

export function navigateToPortalToolTarget(
  navigation: PortalToolNavigation,
): void {
  switch (navigation.tabType) {
    case 'replay': {
      if (navigation.sessionId) {
        useReplaySessionStore.getState().setActiveSession(navigation.sessionId);
      }
      focusReplayView();
      return;
    }
    case 'intercept': {
      openMainContentTabForType({
        id: 'intercept',
        title: 'Intercept',
        type: 'intercept',
      });
      return;
    }
    case 'match-replace': {
      if (navigation.ruleId) {
        useProxyStore.getState().setMatchReplaceFocusRuleId(navigation.ruleId);
      }
      openMainContentTabForType({
        id: 'match-replace',
        title: 'Match & Replace',
        type: 'match-replace',
      });
      return;
    }
    case 'settings-mcp-connection': {
      useProxyStore
        .getState()
        .setActiveApplicationSettingsTab('mcp-connection');
      return;
    }
    default: {
      const exhaustiveCheck: never = navigation.tabType;
      return exhaustiveCheck;
    }
  }
}
